export default "__VITE_ASSET__BLwCXN7O__"